/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectGroupsControllerGetProjectGroupsQueryResponse, ProjectGroupsControllerGetProjectGroupsPathParams, ProjectGroupsControllerGetProjectGroupsQueryParams, ProjectGroupsControllerGetProjectGroups400, ProjectGroupsControllerGetProjectGroups401, ProjectGroupsControllerGetProjectGroups403 } from "../../models/projectGroupsController/ProjectGroupsControllerGetProjectGroups";

function getProjectGroupsControllerGetProjectGroupsUrl(teamId: ProjectGroupsControllerGetProjectGroupsPathParams["teamId"]) {
  const res = { method: 'GET', url: `/api/v1/teams/${teamId}/project-groups` as const }  
  return res
}

/**
 * @summary Get project groups by field for a team
 * {@link /api/v1/teams/:teamId/project-groups}
 */
export async function projectGroupsControllerGetProjectGroups(teamId: ProjectGroupsControllerGetProjectGroupsPathParams["teamId"], params: ProjectGroupsControllerGetProjectGroupsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectGroupsControllerGetProjectGroupsQueryResponse, ResponseErrorConfig<ProjectGroupsControllerGetProjectGroups400 | ProjectGroupsControllerGetProjectGroups401 | ProjectGroupsControllerGetProjectGroups403>, unknown>({ method : "GET", url : getProjectGroupsControllerGetProjectGroupsUrl(teamId).url.toString(), params, ... requestConfig })  
  return res.data
}